export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const EDIT_NOTIFICATION = "EDIT_NOTIFICATION";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const RESET_NOTIFICATION = "RESET_NOTIFICATION";
export const ERROR_NOTIFICATION = "ERROR_NOTIFICATION";
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
